import { useState, useEffect } from 'react';

import prizes from 'data/sources.json';

import { PrizesData } from 'types/prize';

export const usePrize = () => {
  const [data, setData] = useState<PrizesData | null>(null);

  useEffect(() => {
    setData(prizes);
  }, []);

  return data;
};
